import React from 'react';
import { BadgeAlt as Badge } from '@cargomatic/ui';
import { cn } from 'utils/ui/classes';
import { humanize } from 'underscore.string';
function getColor(status) {
    switch (status) {
        case 'confirmed':
            return 'bg-green-100 text-green-800 hover:bg-green-100';
        case 'awaiting':
            return 'bg-yellow-100 text-yellow-800 hover:bg-yellow-100';
        case 'expired':
            return 'bg-gray-100 text-gray-800 hover:bg-gray-100';
        case 'declined':
            return 'bg-red-100 text-red-800 hover:bg-red-100';
        default:
            return 'bg-gray-100 text-gray-800 hover:bg-gray-100';
    }
}
export function AccessorialRateStatusBadge({ className = '', status }) {
    if (!status)
        return null;
    return (React.createElement(Badge, { className: cn('text-xs whitespace-nowrap self-start shrink-0 grow-0', getColor(status), className) }, humanize(status)));
}
